/**
 * Resolve which of a section's associated slides is the "main" (large) page:
 * the coach-selected `selectedPage` when it belongs to this section, else the
 * section's first associated slide (by `sort_order`). Returns null when the
 * section has no visuals.
 *
 * Lives in its own module (not `SectionSlides.tsx`) so consumers that need the
 * main page WITHOUT rendering the component — e.g. the participant card
 * measuring the shown page's aspect ratio to fit the beige mat (MED-1274) —
 * apply the exact same selection rule the component renders. The parameter is
 * typed structurally so this file need not import from `SectionSlides` (no
 * import cycle); `SectionSlideVisual[]` assigns to it directly.
 */
export function resolveMainPage(
  visuals: ReadonlyArray<{ slide_page: number; sort_order: number }>,
  selectedPage?: number | null
): number | null {
  const sorted = visuals.slice().sort((a, b) => a.sort_order - b.sort_order);
  if (sorted.length === 0) return null;
  return selectedPage != null && sorted.some((v) => v.slide_page === selectedPage)
    ? selectedPage
    : sorted[0].slide_page;
}
